import { objectToQueryString } from "../../../shared/utils";

export function studiesAudienceSetup(args) {
  return {
    study: args.study,
    studyBatch: args.studyBatch,
    audiencePreview: {
      initiallyLoaded: false,
      loaded: false,
    },
    viewAllOpen: false,
    init() {
      this.loadPreview();

      const watchedAttrs = [
        "studyBatch.target_audience",
        "studyBatch.target_role",
        "studyBatch.squad_ids",
        "studyBatch.tag_ids",
        "studyBatch.exclude_recent_recipients",
        "studyBatch.exclude_ooo",
        "studyBatch.snapshot_response_segment",
        "studyBatch.snapshot_response_segment_item_id",
        "studyBatch.snapshot_response_segment_item_type",
      ];

      this.$watch(watchedAttrs.join(", "), () => this.loadPreview());
    },
    get queryString() {
      const {
        target_audience,
        target_role,
        squad_ids,
        tag_ids,
        exclude_recent_recipients,
        exclude_ooo,
        snapshot_response_segment_item_type,
        snapshot_response_segment_item_id,
        snapshot_response_segment,
        snapshot_id,
      } = this.studyBatch;

      return objectToQueryString({
        target_audience,
        target_role,
        squad_ids: squad_ids.join(","),
        tag_ids: tag_ids.join(","),
        exclude_recent_recipients,
        exclude_ooo,
        snapshot_response_segment_item_type,
        snapshot_response_segment_item_id,
        snapshot_response_segment,
        snapshot_id,
      });
    },
    loadPreview() {
      this.audiencePreview.loaded = false;

      fetch(`${args.previewEndpoint}?${this.queryString}`)
        .then((response) => response.json())
        .then((data) => {
          this.audiencePreview = Object.assign(data, {
            loaded: true,
            initiallyLoaded: true,
          });
        });
    },
    get audiencePreviewCsvUrl() {
      return `${args.previewEndpoint}?format=csv&${this.queryString}`;
    },
    handleResponseSegmentChange(val) {
      this.studyBatch.snapshot_response_segment_item_type = val.item?.type;
      this.studyBatch.snapshot_response_segment_item_id = val.item?.id;
      this.studyBatch.snapshot_response_segment = val.segment?.id;
      this.studyBatch.snapshot_id = val.snapshot_id;
    },

    // Stuff for manual audience form
    manualAudienceFormOpen: args.manualAudienceFormOpen,
    useCsv: args.useCsv,
    filename: null,
    emailList: "",
    removeFile() {
      document.getElementById("file-input").value = null;
      this.filename = null;
    },
    handleFile(e) {
      const file = e.target.files[0];
      this.filename = file.name;
    },
    get manualListFormValid() {
      return (
        (this.useCsv && !!this.filename) || (!this.useCsv && !!this.emailList)
      );
    },
    get isValid() {
      return !!this.audiencePreview?.total && this.audiencePreview.total > 0;
    },
  };
}
